import React from 'react';

import AuditeeProofForm from './Auditor.js';

export default function Admin() {

  return <AuditeeProofForm />;
}